export enum Roles {
  SUPER_ADMIN = 'SpAdm',
  ADMIN = 'Admin',
  AGENCY = 'Agency',
  // LEADER = "Leader",
  SPVISOR = 'SpVisor',
  MC = 'Mc',
  OIL_MC = 'OilMc',
  ZO_MC = 'ZOMc',
}

export const RolesName = {
  [Roles.SUPER_ADMIN]: 'Quản trị viên',
  [Roles.AGENCY]: 'Đại lý',
  // [Roles.LEADER]: "Trưởng nhóm",
  [Roles.SPVISOR]: 'Nhân viên đối soát',
  [Roles.ADMIN]: 'Admin',
  [Roles.MC]: 'Đối tác',
  [Roles.ZO_MC]: 'Merchant ZenOne',
  [Roles.OIL_MC]: 'Merchant',
};

export enum SubRolesOfAgency {
  STAFF = 'Staff',
  DRIVER = 'Driver',
  PARTNER = 'Partner',
  CUSTOMER = 'Customer',
}

export const SubRolesNameOfAgency = {
  [SubRolesOfAgency.STAFF]: 'Nhân viên',
  [SubRolesOfAgency.DRIVER]: 'Tài xế',
  [SubRolesOfAgency.PARTNER]: 'Đối tác Xăng dầu',
  [SubRolesOfAgency.CUSTOMER]: 'Khách hàng',
};

// export enum Roles {
//   ADMIN = 'Quản trị viên',
//   AGENCY = 'Đại lý',
//   LEADER = 'Trưởng nhóm',
//   SPVISOR = 'Nhân viên đối soát',
// }
